import React, { useState, useEffect } from 'react';
import MapillaryViewer from './MapillaryViewer';

const checkLoaded = callback => {
  if (window.mapillary) {
    return callback();
  }

  return setTimeout(() => checkLoaded(callback), 1000);
};

const Mapillary = ({ imageKey, ...props }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timeout = checkLoaded(() => setLoaded(true));
    return () => clearTimeout(timeout);
  }, []);

  if (!loaded || !imageKey) {
    return null;
  }

  return (
    <MapillaryViewer imageKey={imageKey} {...props} />
  );
};

export default Mapillary;
